import * as React from 'react';
import { connect } from 'react-redux';
import { setFiltroPublicacion } from '../../actions/publicacionesActions';
import {
    fetchSeller,
    editSeller,
    fetchSellersFilter,
    fetchSellers
} from '../../actions/sellersActions';

class Moderador extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            didEdit: false,
            estado: "",
            envioPropio: "",
        }
    };

    componentDidMount() {
        if (this.props.seller.estado == "") {
            let seller = this.props.seller;
            seller["estado"] = "inactivo";
            this.props.editSeller(seller);
        }
    }

    componentWillReceiveProps = () => {
        if (this.didEdit) {
            this.props.fetchSeller(this.props.id);
            this.setState({ didEdit: false });
        }
    }

    myChangeHandler = (event) => {
        this.setState({ didEdit: true })
        let seller = this.props.seller;
        seller[event.target.name] = event.target.value;
        this.props.editSeller(seller);
    }

    onSwitchChange = () => {
        let activo = document.querySelector('#switchEstado').checked;
        let valueEstado = activo ? "activo" : "inactivo"

        this.setState({ estado: valueEstado, didEdit: true });

        let seller = this.props.seller;
        seller["estado"] = valueEstado;
        this.props.editSeller(seller);

        if (this.props.history.location.pathname != "/Sellers/Nuevo") {
            this.props.changeTab(0);
            this.props.changeTab(3);
        }
    }

    onSwitchChangeEnvioPropio = () => {
        let activo = document.querySelector('#switchEnvioPropio').checked;
        let envioPropio = activo;

        this.setState({ envioPropio: envioPropio, didEdit: true });

        let seller = this.props.seller;
        seller["envioPropio"] = envioPropio;
        this.props.editSeller(seller);

        if (this.props.history.location.pathname != "/Sellers/Nuevo") {
            this.props.changeTab(0);
            this.props.changeTab(3);
        }
    }


    render() {
        return (
            <div className="tab-pane p-20 active " name="datos" id="home2" role="tabpanel">
                <div className="row">
                    <div className="col-sm-12 col-md-6 col-lg-6">

                        <div className="form-group">
                            <label>Sufijo SKU</label>
                            <input
                                type="text"
                                name="sufijo"
                                maxLength="3"
                                className="form-control"
                                value={this.props.seller.sufijo}
                                onChange={this.myChangeHandler}
                            />
                        </div>

                        <div className="form-group">
                            <label>Id Empresa Enviopack</label>
                            <input
                                type="number"
                                className="form-control"
                                value={this.props.seller.idEmpresaEnviopack}
                                onChange={this.myChangeHandler}
                                name="idEmpresaEnviopack"
                            />
                        </div>

                        <div className="form-group row">
                            <label className="control-label col-auto">Logistica propia</label>
                            <div className="col-auto">
                                <div className="custom-control custom-switch">
                                    <input
                                        type="checkbox"
                                        id="switchEnvioPropio"
                                        className="custom-control-input me-2"
                                        onChange={this.onSwitchChangeEnvioPropio}
                                        checked={this.props.seller.envioPropio}
                                    />
                                    <label
                                        for="switchEnvioPropio"
                                        className="custom-control-label"
                                    >
                                        {this.props.seller.envioPropio ? "Habilitada" : "Inhabilitada"}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    seller: JSON.stringify(state.general.generalObject) != "{}"
        ? state.general.generalObject
        : state.sellers.seller
});

export default connect(mapStateToProps, {
    setFiltroPublicacion,
    fetchSellersFilter,
    fetchSellers,
    fetchSeller,
    editSeller
})(Moderador);